module.exports = "/_next/static/images/dda9fcf8094550091c2186c88749ecc7-sanpablo-1.jpg.webp";